import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3fd13cd1")

_pushScopeId("data-v-3fd13cd1")
const _hoisted_1 = { class: "table-container" }
const _hoisted_2 = {
  key: 0,
  class: "action-col"
}
const _hoisted_3 = {
  key: 0,
  class: "action-col-td"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z" })
], -1)
const _hoisted_5 = {
  key: 1,
  class: "download icon svg-rotate"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z" })
], -1)
const _hoisted_7 = {
  key: 2,
  class: "disabled-download icon"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M450-81q-78-6-145.5-39T187-206.5q-50-53.5-78.5-124T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480v19q-17-11-39.5-21.5T799-500q-8-126-99.5-213T480-800q-56 0-105.5 18T284-732l245 245q-19 8-36.5 18.5T458-446L228-676q-32 41-50 90.5T160-480q0 99 53.5 177.5T352-187q18 28 45 57t53 49Zm230-79q59 0 109.5-27t80.5-73q-30-46-80.5-73T680-360q-59 0-109.5 27T490-260q30 46 80.5 73T680-160Zm0 80q-96 0-171.5-50.5T400-260q33-79 108.5-129.5T680-440q96 0 171.5 50.5T960-260q-33 79-108.5 129.5T680-80Zm0-120q-25 0-42.5-17.5T620-260q0-25 17.5-42.5T680-320q25 0 42.5 17.5T740-260q0 25-17.5 42.5T680-200Z" })
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "«", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "»", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.canShowTable)
      ? (_openBlock(), _createBlock("table", {
          key: 0,
          class: { 'wide-table': _ctx.dataToDisplay && _ctx.dataToDisplay.length > 0 && _ctx.getColumnCount() > 8 }
        }, [
          _createVNode("thead", null, [
            _createVNode("tr", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.container.columns, (field) => {
                return (_openBlock(), _createBlock("th", { key: field }, _toDisplayString(field.title), 1))
              }), 128)),
              (_ctx.canShowDownload)
                ? (_openBlock(), _createBlock("th", _hoisted_2))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataToDisplay, (rows, index) => {
              return (_openBlock(), _createBlock("tr", _mergeProps({ key: index }, _ctx.getDocumentId(rows), {
                class: { 'hide-row': (index > 8 && _ctx.showMoreOption) ? true : false }
              }), [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.container.columns, (field) => {
                  return (_openBlock(), _createBlock("td", { key: field }, [
                    _createVNode("span", {
                      innerHTML: _ctx.getCellValue(rows, field.key)
                    }, null, 8, ["innerHTML"])
                  ]))
                }), 128)),
                (_ctx.canShowDownload)
                  ? (_openBlock(), _createBlock("td", _hoisted_3, [
                      (rows.active_download_url && !rows.validatingUrl)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "download x icon",
                            onClick: ($event: any) => (_ctx.previewFile(rows))
                          }, [
                            _hoisted_4
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (rows.validatingUrl)
                        ? (_openBlock(), _createBlock("a", _hoisted_5, [
                            _hoisted_6
                          ]))
                        : _createCommentVNode("", true),
                      (!rows.active_download_url)
                        ? (_openBlock(), _createBlock("a", _hoisted_7, [
                            _hoisted_8
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 16))
            }), 128)),
            (_ctx.dataToDisplay && !_ctx.dataToDisplay.length)
              ? (_openBlock(), _createBlock("tr", _hoisted_9, [
                  _createVNode("td", {
                    colspan: _ctx.getColumnCount(),
                    class: "text-center"
                  }, _toDisplayString(_ctx.$t("default.alert.no_record_found")), 9, ["colspan"])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("label", {
      class: "show-more",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleShowMore()))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("default.button.show_more")) + " ", 1),
      _hoisted_10
    ], 512), [
      [_vShow, _ctx.canShowMoreOption && _ctx.showMoreOption]
    ]),
    _withDirectives(_createVNode("label", {
      class: "show-more",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleShowMore()))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("default.button.show_less")) + " ", 1),
      _hoisted_11
    ], 512), [
      [_vShow, _ctx.canShowMoreOption && !_ctx.showMoreOption]
    ])
  ]))
})